@if (paginationStore().isInitialLoad()) {
  <div class="run-grid" aria-label="Loading job runs">
    @for (row of skeletonItems; track row) {
      <div class="cui-card run-card run-card--skeleton">
        <div class="run-card__status"></div>
        <div class="run-card__content">
          <div
            class="cui-skeleton run-card__skeleton-line run-card__skeleton-line--title"
            aria-hidden="true">
            &nbsp;
          </div>
          <div class="cui-skeleton run-card__skeleton-line" aria-hidden="true">&nbsp;</div>
        </div>
        <div
          class="cui-skeleton run-card__skeleton-line run-card__skeleton-line--date"
          aria-hidden="true">
          &nbsp;
        </div>
      </div>
    }
  </div>
} @else if (runs().length) {
  <div class="run-grid">
    @for (run of runs(); track run.id) {
      <a class="cui-card cui-card--interactive run-card" [routerLink]="run.routerLink">
        <div class="run-card__status">
          <span
            class="material-symbols-outlined"
            [class.is-success]="run.color === 'success'"
            [class.is-error]="run.color === 'error'"
            [class.is-running]="run.color === 'warning'">
            {{ run.icon }}
          </span>
        </div>
        <div class="run-card__content">
          <div class="run-card__header">
            <strong>{{ run.title }} #{{ run.id }}</strong>
            <span>{{ run.status }}</span>
          </div>
          <p class="run-preview__parameters" [title]="run.parameterSummary">
            {{ run.parameterSummary }}
          </p>
        </div>
        <time class="run-card__date">{{ formatDateTime(run.modified) }}</time>
      </a>
    }
  </div>
} @else if (paginationStore().loadFailed()) {
  <p class="empty-state">Job runs could not be loaded.</p>
} @else {
  <p class="empty-state">{{ emptyMessage() }}</p>
}

@if (paginationStore().hasMore()) {
  <div class="load-more">
    <button
      cuiButton
      class="cui-text-muted"
      [loading]="paginationStore().loading()"
      variant="plain"
      type="button"
      (click)="paginationStore().loadMore()">
      Show more
    </button>
  </div>
}
